import { render } from "./UserAgreementEn.vue?vue&type=template&id=6bdd3b92&scoped=true"
import script from "./UserAgreementEn.vue?vue&type=script&lang=js"
export * from "./UserAgreementEn.vue?vue&type=script&lang=js"

import "./UserAgreementEn.vue?vue&type=style&index=0&id=6bdd3b92&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bdd3b92"]])

export default __exports__